import { motion } from "framer-motion";
import { COMPANY } from "../../lib/site";

export default function Founder() {
  return (
    <section
      data-testid="founder-section"
      className="relative py-28 md:py-40 px-6 md:px-10 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="lg:col-span-5 relative"
        >
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src={COMPANY.founderPhoto}
              alt="Sneha Dixit, Founder"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
            <div className="absolute -top-6 -right-6 w-32 h-32 border border-[#D4AF37] -z-10" />
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-[#D4AF37]/10 -z-10" />
          </div>
          <div className="absolute bottom-8 left-8 right-8 glass-strong p-5">
            <div className="font-serif text-3xl text-white font-light">
              {COMPANY.founder}
            </div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37] mt-1">
              Founder · S Mahadeva Properties
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="lg:col-span-7"
        >
          <div className="eyebrow mb-4">About the Founder</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white font-light leading-[1.05]">
            A decade of{" "}
            <span className="gold-gradient-text italic">trust</span>, built one
            family at a time.
          </h2>
          <div className="divider-gold my-8 !w-20" />
          <p className="text-white/70 text-lg font-light leading-relaxed">
            S Mahadeva Properties was established with the mission of helping
            investors make informed real estate decisions that secure their
            future and build generational wealth. Through transparency, trust,
            and expert guidance, we have successfully assisted hundreds of
            clients in identifying high-potential investment opportunities
            across Dholera Smart City.
          </p>
          <p className="text-white/60 text-base font-light leading-relaxed mt-6">
            With a PAN-India client base and over 1500+ acres facilitated,
            Sneha Dixit leads with a singular philosophy — verified
            opportunities, honest counsel, and lifelong partnerships.
          </p>

          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { value: "10+", label: "Years" },
              { value: "500+", label: "Clients" },
              { value: "1500+", label: "Acres" },
              { value: "PAN", label: "India" },
            ].map((s) => (
              <div key={s.label}>
                <div className="font-sans text-5xl md:text-6xl text-[#D4AF37] font-bold tracking-tight">
                  {s.value}
                </div>
                <div className="text-[10px] tracking-[0.25em] uppercase text-white/50 mt-2">
                  {s.label}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 font-serif italic text-2xl text-white/80">
            — Sneha Dixit
          </div>
        </motion.div>
      </div>
    </section>
  );
}
